import React, { Fragment } from 'react';
import { version } from '../../../package.json';

import './index.scss';

const getYear = () => {
  const date = new Date();
  return date.getFullYear();
}

const Footer: React.FC = () => {
  return (
    <Fragment>
      <hr></hr>
      <div className='footer'>
        <span>
          Linx Sistemas - {getYear()}
        </span>
        <span>
          Versão {version}
        </span>
      </div>
    </Fragment>
  )
}

export default Footer;
